import { Controller } from "@hotwired/stimulus"
import Splide from '@splidejs/splide'
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'

export default class extends Controller {
  static values = { options: Object }

  connect() {
    // Initialize immediately - no delay needed
    this.initializeSlider()
  }

  disconnect() {
    if (this.splide) {
      this.splide.destroy()
    }
  }

  initializeSlider() {
    try {
      // Create Splide instance with options
      this.splide = new Splide(this.element, this.optionsValue)

      // Check if Auto Scroll is needed based on options
      const needsAutoScroll = this.optionsValue.autoScroll &&
                             (this.optionsValue.autoScroll.autoStart !== false)

      if (needsAutoScroll) {
        // Mount the slider with Auto Scroll extension
        this.splide.mount({ AutoScroll })
      } else {
        // Mount the slider without Auto Scroll
        this.splide.mount()
      }

      // Ensure slider is visible once initialized
      const reveal = () => {
        try {
          this.element.style.visibility = 'visible'
          this.element.style.opacity = ''
        } catch (_) { /* no-op */ }
      }
      this.splide.on('mounted', () => {
        reveal()
        this.updateArrowsVisibility()
      })
      this.splide.on('ready', () => {
        reveal()
        this.updateArrowsVisibility()
      })
      this.splide.on('resize', () => this.updateArrowsVisibility())
      this.splide.on('updated', () => this.updateArrowsVisibility())
      // Fallback reveal in case events don't fire
      setTimeout(reveal, 0)

    } catch (error) {
      console.error('Failed to initialize Splide slider:', error)
      // In the worst case, reveal static content so the list is visible
      try {
        this.element.style.visibility = 'visible'
        this.element.style.opacity = ''
      } catch (_) { /* no-op */ }
    }
  }

  updateArrowsVisibility() {
    try {
      if (!this.splide) return
      const slidesCount = this.splide.length || (this.splide.Components?.Slides?.get()?.length ?? 0)
      const perPage = this.splide.options?.perPage || 1
      const shouldShowArrows = slidesCount > perPage
      if (this.splide.options?.arrows !== shouldShowArrows) {
        this.splide.options = { arrows: shouldShowArrows }
      }
    } catch (_) { /* no-op */ }
  }
}
